// Baroom React SPA entry point
import React from 'react';
import { createRoot } from 'react-dom/client';
import BaroomApp from './BaroomApp';
import './index.css';
import './styles/animations.css';
import './styles/a11y.css';
import './i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Polyfill for global
window.global = window;

// Prevent double-tap to zoom and pinch zoom (same as Nidoux)
(() => {
  const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  // Prevent double-tap to zoom
  let lastTouchEnd = 0;
  document.addEventListener('touchend', (e) => {
    const now = Date.now();
    if (now - lastTouchEnd <= 300) {
      e.preventDefault();
    }
    lastTouchEnd = now;
  }, { passive: false });

  // Prevent pinch zoom (all devices)
  document.addEventListener('touchmove', (e) => {
    if (e.touches.length > 1) {
      e.preventDefault();
    }
  }, { passive: false });

  if (isiOS) {
    // Block pinch gestures on iOS
    ['gesturestart', 'gesturechange', 'gestureend'].forEach(type => {
      document.addEventListener(type, (e) => e.preventDefault(), { passive: false });
    });
  }
})();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <BaroomApp />
  </React.StrictMode>
);

// Register the PWA service worker for conservative offline app-shell caching.
// This is a no-op in development, inside the Capacitor native WebView, and in
// non-secure contexts; any failure is caught and ignored so it never blocks boot.
serviceWorkerRegistration.register();
